import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { border } from 'styles'
import { title } from 'styles/texts'
import {
  roomIsPendingSelector,
  messagesIsPending,
  roomMessageIdsSelector,
  roomUsersSelector,
  roomTypeSelector,
  roomUserIdSelector,
} from 'selectors'
import { subscribeToMessages, unsubscribeFromMessages } from 'actions'

import Spinner from 'components/Spinner'
import Message from './Message'
import ChatField from 'components/chat/ChatField'
import withSpinner from 'components/withSpinner'

const Wrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

const Heading = styled.div`
  ${title};
  padding: 25px 0;
  text-align: center;
  border-bottom: ${border};
  flex-shrink: 0;
`

const User = styled(Link)``

const List = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px 30px;
  display: flex;
  flex-direction: column-reverse;
`

const Welcome = styled.div`
  ${title};
  flex-grow: 1;
  text-align: center;
  max-width: 390px;
  margin: 140px auto 0;
`

class Messages extends React.Component {
  componentDidMount() {
    this.props.subscribeToMessages(this.props.roomId)
  }

  componentWillUnmount() {
    this.props.unsubscribeFromMessages(this.props.roomId)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.messageIds.length > prevProps.messageIds.length && this.el) {
      this.el.scrollTop = this.el.scrollHeight
    }
    if (this.props.roomId !== prevProps.roomId) {
      this.props.unsubscribeFromMessages(prevProps.roomId)
      this.props.subscribeToMessages(this.props.roomId)
    }
  }

  content = () => {
    if (this.props.isPending) {
      return <Spinner />
    } else if (
      this.props.messageIds.length === 0 &&
      this.props.roomType === 'feedback'
    ) {
      return (
        <Welcome>
          <span
            style={{
              display: 'inline-block',
              fontSize: 50,
              marginBottom: 20,
            }}
            role="img"
            aria-label="chat bubble">
            👋
          </span>
          <div>
            Hei! Her kan du snakke med de som lager Spir. Er det noe du lurer på
            eller ønsker du å gi oss feedback? Fyr løs!
          </div>
        </Welcome>
      )
    } else {
      return (
        <List innerRef={el => (this.el = el)}>
          {this.props.messageIds
            .reverse()
            .map(messageId => (
              <Message
                key={messageId}
                roomId={this.props.roomId}
                messageId={messageId}
              />
            ))}
        </List>
      )
    }
  }

  render() {
    return (
      <Wrapper className={this.props.className}>
        {this.props.heading && (
          <Heading>
            {this.props.roomUsers &&
              this.props.roomUsers.map(({ name, id }, index, { length }) => (
                <React.Fragment>
                  <User to={`/users/${id}`}>{name}</User>
                  {index !== length - 1 && ', '}
                </React.Fragment>
              ))}
          </Heading>
        )}
        {this.content()}
        <ChatField small={this.props.small} roomId={this.props.roomId} />
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, { roomId }) => ({
  messageIds: roomMessageIdsSelector(state, roomId) || [],
  userId: roomUserIdSelector(state, roomId),
  isPending: messagesIsPending(state, roomId),
  roomType: roomTypeSelector(state, roomId),
  roomUsers: roomUsersSelector(state, roomId) || [],
})

const mapDispatchToProps = {
  subscribeToMessages,
  unsubscribeFromMessages,
}

export default withSpinner(
  roomIsPendingSelector,
  connect(mapStateToProps, mapDispatchToProps)(Messages)
)



// WEBPACK FOOTER //
// ./src/components/chat/Messages.js